import React from 'react'
import CloseButton from 'react-bootstrap/CloseButton'
import AddIntent from './addIntent'

interface IProps {
  intent: any
  closeModal: () => void
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  newIntentId: any
  setNewIntentId: any
}

const AddIntentModal: React.FC<IProps> = ({
  intent,
  closeModal,
  inputJson,
  setInputJson,
  newIntentId,
  setNewIntentId
}) => {
  return (
    <div className='card h-300px w-300px'>
      <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
        <span className='mb-2 me-auto'>
          {/* <span className='ms-1 badge bg-info fs-5'># New Intent</span> */}
        </span>
        <CloseButton onClick={closeModal} />
      </div>

      <AddIntent
        inputJson={inputJson}
        setInputJson={setInputJson}
        intent={intent}
        closeModal={closeModal}
        newIntentId={newIntentId}
        setNewIntentId={setNewIntentId}
      />
    </div>
  )
}

export default AddIntentModal
